<template>
  <div style="background-color:#eee;">
    <span v-for="image in images">
      <span v-if="image.request_url">
        <a :href="'/annotations/' + extent_id + '/?url=' + image.request_url" target="_blank">
          <img :src="image.url" style="width:18%;margin:1%;" />
        </a>
      </span>
      <span v-else>
          <img :src="image.url" style="width:18%;margin:1%;" />
      </span>
    </span>
  </div>

</template>

<script>
export default {
  name: "Gallery",
  props: ['endPoint','extent_id'],
  mounted() {
    this.get_images()
  },
  watch: {
    endPoint: function(val) {
      this.get_images()
    }
  },
  methods: {
    get_images() {
      console.log('in get_images')
      if (this.endPoint) {
        console.log('about to make the request to get the images')
        axios.get(this.endPoint)
            .then(response => {
              this.images = response.data
            })
            .catch(error => {
              console.log("oops getting images")
            })
      }
    },
  },
  data() {
    return {
      images: null,
    }
  }
}
</script>

<style scoped>

</style>